import { DashboardFeature, DashboardResearcherFeature } from '@vivli/features/dashboard/feature';
import { useUserPermissions } from '@vivli/features/users/infrastructure/hook';
import { useAssignedAppTypeContext } from '@vivli/core/infrastructure/context';

export const DashboardFeatureRouteWrapper = () => {
    const { isOrgOrVivliAdmin, isDataProvider, isIRPApprover } = useUserPermissions();
    const { isAmr } = useAssignedAppTypeContext();

    const userHasCtOrgRoles = !isAmr && (isOrgOrVivliAdmin || isDataProvider || isIRPApprover);
    return userHasCtOrgRoles ? <DashboardFeature /> : <DashboardResearcherFeature />;
};
